module.exports = __webpack_public_path__ + "static/media/coil-medium.ce73e9eb.svg";